import { render, staticRenderFns } from "./SurgeryData.vue?vue&type=template&id=49579624&scoped=true&"
import script from "./SurgeryData.vue?vue&type=script&lang=js&"
export * from "./SurgeryData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49579624",
  null
  
)

export default component.exports